// Action types
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const UPDATE_WHY_HERE = 'UPDATE_WHY_HERE'; // ✅ New action type
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_IS_JOURNEY_CHANGE = 'UPDATE_IS_JOURNEY_CHANGE';

// Action creator to store user data
export const updateUserData = (userData) => {
  return {
    type: UPDATE_USER_DATA,
    payload: userData,
  };
};

export const updateIsJourneyChange = (isJourneyChange) => {
  return {
    type: UPDATE_IS_JOURNEY_CHANGE,
    payload: isJourneyChange
  }
}

// ✅ Action creator to update only the 'WhyHere' field in userData
export const updateWhyHere = (newWhyHereValue) => {
  return {
    type: UPDATE_WHY_HERE,
    payload: newWhyHereValue,
  };
};

// Initial state for user data
const initialState = {
  userData: {}, // Empty object initially
  isJourneyChange: false,
};

// Reducer to handle user data actions
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_DATA:
      return {
        ...state,
        userData: action.payload, // Replace full userData object
      };
    case UPDATE_WHY_HERE:
      return {
        ...state,
        userData: {
          ...state.userData, // ✅ Keep other fields intact
          WhyHere: action.payload, // ✅ Only update 'WhyHere' field
        },
      };
    case LOGOUT_USER:
      return {
        ...state,
        userData: {}, // Clear user data on logout
      };
    case UPDATE_IS_JOURNEY_CHANGE:
      return {
        ...state,
        isJourneyChange: action.payload,
      }
    default:
      return state;
  }
};

export default userReducer;